import React from "react";

import ic_switch_on from "ASSETS/Images/ic_switch_on.svg";
import ic_switch_off from "ASSETS/Images/ic_switch_off.svg";

const Switch = (props) => {

  return (
    <div className={props.disabled ? "cursorDisabled switchIcon" : "cursorPointer switchIcon"}>
      {props.switchOn ? <img
        src={props.disabled ? ic_switch_off : ic_switch_on}
        className={props.disabled ? "flipSwitch": ""}
        title={props.title}
        onClick={() => {
          if (props.disabled) {
            props.toggleSwitch(true)
          } else {
            props.toggleSwitch(false)
          }
        }}
      /> : <img
        src={ic_switch_off}
        title={props.title}
        onClick={() => {
          if (props.disabled) {
            props.toggleSwitch(false)
          } else {
            props.toggleSwitch(true)
          }

        }}
      />}
    </div>
  );
}

export default Switch;